import { RequestStatus } from '../../constants';
import { BFFEndpointsEnum } from '../hooks/useURLBuilder';

import packageContext from './package-context';

export type RequestCompletePayload<T> = {
	data: T;
	status: RequestStatus.COMPLETE;
};

export type RequestErrorPayload = {
	data: null;
	error: any;
	status: RequestStatus.ERROR;
};

export function isLocalHost(): boolean {
	const host = window.location.host;
	return host.includes('localhost') && host.includes(':');
}

export async function fetchJSON<T>(
	url: string,
	init?: RequestInit,
): Promise<RequestCompletePayload<T> | RequestErrorPayload> {
	try {
		const response = await fetch(url, {
			...init,
			credentials: 'include',
			headers: {
				'Atl-BFF-Payload-Version': packageContext.packageVersion,
				...init?.headers,
			},
		});

		// Validate response status and throw an error for non-OK responses, except for specific cases handled by feature flags.
		if (!response.ok) {
			const isAvailableProductsEndpoint = URL.parse(url)?.pathname.includes(
				BFFEndpointsEnum.AVAILABLE_PRODUCTS,
			);

			// The Available Products endpoint returns a 403 status code exclusively from blockBotsMiddleware.
			if (response.status === 403 && isAvailableProductsEndpoint) {
				// Return an empty list of sites to prevent pollinator from treating this as a failed request.
				return {
					status: RequestStatus.COMPLETE,
					data: {
						sites: [],
					} as T,
				};
			}

			throw new Error(`Failed to fetch data: ${response.status} ${response.statusText}`);
		}

		const jsonResponse = await response.json();

		return {
			status: RequestStatus.COMPLETE,
			data: jsonResponse,
		};
	} catch (e) {
		return {
			status: RequestStatus.ERROR,
			error: e,
			data: null,
		};
	}
}
